// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__BQPK3","cards":"dashboard_cards__2dTeO"};